import {
	CoffeeOutlined, EnvironmentOutlined, HomeOutlined,
	LoginOutlined,
	LogoutOutlined, ShoppingOutlined, UserOutlined
} from "@ant-design/icons";
import { ROLES } from "./permissions";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Inicio",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	meals: {
		key: "meals",
		slug: "meals",
		to: "/meals",
		title: "Platos",
		icon: <CoffeeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	ingredients: {
		key: "ingredients",
		slug: "ingredients",
		to: "/ingredients",
		title: "Ingredientes",
		icon: <ShoppingOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	zones: {
		key: "zones",
		slug: "zones",
		to: "/zones",
		title: "Zonas",
		icon: <EnvironmentOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},


	users: {
		key: "users",
		slug: "users",
		to: "/users",
		title: "Usuarios",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},
};
